import React from 'react';
import PropTypes from 'prop-types';
import { TypeRankingsEntities } from 'client/data/models/type-rankings-entities';
import { getAnchorName, hasSubsegments } from 'site-modules/shared/utils/upper-funnel/type-rankings';
import { AnchorNavStickyDropdown } from 'site-modules/shared/components/anchor-nav-sticky/anchor-nav-sticky-dropdown';

export function AnchorNavDropdown({
  vehicleEditorialRankings,
  mostSoldTypeGraphTitle,
  type,
  title,
  className,
  titleClassName,
  hasSeparator,
  isMobile,
  containerClassName,
  stickyClassName,
}) {
  const withSubsegments = hasSubsegments(vehicleEditorialRankings);

  if (!withSubsegments && !mostSoldTypeGraphTitle) {
    return null;
  }

  let navList = [];

  if (withSubsegments) {
    navList = vehicleEditorialRankings.map(({ displayName }) => ({
      name: displayName,
      hash: `${getAnchorName(displayName)}`,
    }));
  }

  if (mostSoldTypeGraphTitle) {
    navList.push({
      name: mostSoldTypeGraphTitle,
      hash: `best-selling-${type}s`,
    });
  }

  if (navList.length < 2) {
    return null;
  }

  return (
    <AnchorNavStickyDropdown
      className={className}
      titleClassName={titleClassName}
      navList={navList}
      title={title}
      hasSeparator={hasSeparator}
      isMobile={isMobile}
      containerClassName={containerClassName}
      stickyClassName={stickyClassName}
    />
  );
}

AnchorNavDropdown.propTypes = {
  vehicleEditorialRankings: PropTypes.arrayOf(PropTypes.shape(TypeRankingsEntities.VehicleRankingDescription)),
  mostSoldTypeGraphTitle: PropTypes.string,
  type: PropTypes.string.isRequired,
  titleClassName: PropTypes.string,
  stickyClassName: PropTypes.string,
  className: PropTypes.string,
  title: PropTypes.string,
  hasSeparator: PropTypes.bool,
  isMobile: PropTypes.bool,
  containerClassName: PropTypes.string,
};

AnchorNavDropdown.defaultProps = {
  vehicleEditorialRankings: null,
  mostSoldTypeGraphTitle: null,
  className: 'type-anchor-nav mb-1 mt-0',
  titleClassName: 'heading-5 pe-1_25',
  stickyClassName: 'my-0_5 my-md-0_75',
  title: undefined,
  hasSeparator: true,
  isMobile: false,
  containerClassName: 'container',
};
